import React, { Component } from "react";
import {
  Heading,
  Main,
  Grid,
  Button,
  TextInput,
  Select,
  CheckBox,
  Text,
  TextArea
} from "grommet";

import {
  owmGetData,
  saveData,
  getWindDirection,
  dayOfWeek,
  dayOfWeekShort,
  getROBjson,
  getWindSpeed
} from "./data/weather";

import { icons, days, daysShort, wind, windSpeed, warning } from "./data/icons";

class ROB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vannachtTemp: "",
      vannachtIcon: "",
      vannachtWind: "",
      vannachtWarning: false,
      vannachtWarningIcon: "",
      provincieTitle: "",
      provincieTemp: "",
      provincieIcon: "",
      provincieWind: "",
      provincieWarning: false,
      provincieWarningIcon: "",
      belgieTitle: "",
      belgieTemp1: "",
      belgieIcon1: "",
      belgieTemp2: "",
      belgieIcon2: "",
      belgieTemp3: "",
      belgieIcon3: "",
      belgieTemp4: "",
      belgieIcon4: "",
      belgieTemp5: "",
      belgieIcon5: "",
      belgieTemp6: "",
      belgieIcon6: "",
      belgieWind: "",
      belgieWindText: "",
      belgieWind2: "",
      belgieWindText2: "",
      overzichtTitle1: "",
      overzichtIcon1: "",
      overzichtTempMax1: "",
      overzichtTempMin1: "",
      overzichtWindIcon1: "",
      overzichtWindText1: "",
      overzichtTitle2: "",
      overzichtIcon2: "",
      overzichtTempMax2: "",
      overzichtTempMin2: "",
      overzichtWindIcon2: "",
      overzichtWindText2: "",
      overzichtTitle3: "",
      overzichtIcon3: "",
      overzichtTempMax3: "",
      overzichtTempMin3: "",
      overzichtWindIcon3: "",
      overzichtWindText3: "",
      overzichtTitle4: "",
      overzichtIcon4: "",
      overzichtTempMax4: "",
      overzichtTempMin4: "",
      overzichtWindIcon4: "",
      overzichtWindText4: "",
      overzichtTitle5: "",
      overzichtIcon5: "",
      overzichtTempMax5: "",
      overzichtTempMin5: "",
      overzichtWindIcon5: "",
      overzichtWindText5: "",
      overzichtTitle6: "",
      overzichtIcon6: "",
      overzichtTempMax6: "",
      overzichtTempMin6: "",
      overzichtWindIcon6: "",
      overzichtWindText6: "",
      samenvatting: "",
      lastSaved: ""
    };
    this.getData = this.getData.bind(this);
    this.saveDataClick = this.saveDataClick.bind(this);
  }

  componentDidMount() {
    getROBjson().then(data => {
      this.setState({
        vannachtTemp: data.vannacht.temp,
        vannachtIcon: data.vannacht.icon,
        vannachtWind: data.vannacht.wind,
        vannachtWarning: data.vannacht.warning,
        vannachtWarningIcon: data.vannacht.warningIcon,
        provincieTitle: data.dagProvincie.title,
        provincieTemp: data.dagProvincie.temp,
        provincieIcon: data.dagProvincie.icon,
        provincieWind: data.dagProvincie.wind,
        provincieWarning: data.dagProvincie.warning,
        provincieWarningIcon: data.dagProvincie.warningIcon,
        belgieTitle: data.dagBelgie.title,
        belgieTemp1: data.dagBelgie.temp1.temp,
        belgieIcon1: data.dagBelgie.temp1.icon,
        belgieTemp2: data.dagBelgie.temp2.temp,
        belgieIcon2: data.dagBelgie.temp2.icon,
        belgieTemp3: data.dagBelgie.temp3.temp,
        belgieIcon3: data.dagBelgie.temp3.icon,
        belgieTemp4: data.dagBelgie.temp4.temp,
        belgieIcon4: data.dagBelgie.temp4.icon,
        belgieTemp5: data.dagBelgie.temp5.temp,
        belgieIcon5: data.dagBelgie.temp5.icon,
        belgieTemp6: data.dagBelgie.temp6.temp,
        belgieIcon6: data.dagBelgie.temp6.icon,
        belgieWind: data.dagBelgie.wind,
        belgieWindText: data.dagBelgie.windText,
        belgieWind2: data.dagBelgie.wind2,
        belgieWindText2: data.dagBelgie.windText2,
        overzichtTitle1: data.overzicht.temp1.title,
        overzichtIcon1: data.overzicht.temp1.icon,
        overzichtTempMax1: data.overzicht.temp1.tempMax,
        overzichtTempMin1: data.overzicht.temp1.tempMin,
        overzichtWindIcon1: data.overzicht.temp1.windIcon,
        overzichtWindText1: data.overzicht.temp1.windText,
        overzichtTitle2: data.overzicht.temp2.title,
        overzichtIcon2: data.overzicht.temp2.icon,
        overzichtTempMax2: data.overzicht.temp2.tempMax,
        overzichtTempMin2: data.overzicht.temp2.tempMin,
        overzichtWindIcon2: data.overzicht.temp2.windIcon,
        overzichtWindText2: data.overzicht.temp2.windText,
        overzichtTitle3: data.overzicht.temp3.title,
        overzichtIcon3: data.overzicht.temp3.icon,
        overzichtTempMax3: data.overzicht.temp3.tempMax,
        overzichtTempMin3: data.overzicht.temp3.tempMin,
        overzichtWindIcon3: data.overzicht.temp3.windIcon,
        overzichtWindText3: data.overzicht.temp3.windText,
        overzichtTitle4: data.overzicht.temp4.title,
        overzichtIcon4: data.overzicht.temp4.icon,
        overzichtTempMax4: data.overzicht.temp4.tempMax,
        overzichtTempMin4: data.overzicht.temp4.tempMin,
        overzichtWindIcon4: data.overzicht.temp4.windIcon,
        overzichtWindText4: data.overzicht.temp4.windText,
        overzichtTitle5: data.overzicht.temp5.title,
        overzichtIcon5: data.overzicht.temp5.icon,
        overzichtTempMax5: data.overzicht.temp5.tempMax,
        overzichtTempMin5: data.overzicht.temp5.tempMin,
        overzichtWindIcon5: data.overzicht.temp5.windIcon,
        overzichtWindText5: data.overzicht.temp5.windText,
        overzichtTitle6: data.overzicht.temp6.title,
        overzichtIcon6: data.overzicht.temp6.icon,
        overzichtTempMax6: data.overzicht.temp6.tempMax,
        overzichtTempMin6: data.overzicht.temp6.tempMin,
        overzichtWindIcon6: data.overzicht.temp6.windIcon,
        overzichtWindText6: data.overzicht.temp6.windText,
        samenvatting: data.samenvatting.text,
        lastSaved: data.lastSaved
      });
    });
  }

  getData() {
    owmGetData("50.8477584", "4.3641418").then(data => {
      console.log(data);
      this.setState({
        vannachtTemp: Math.round(data.daily[0].temp.night),
        vannachtIcon: data.daily[0].weather[0].id,
        vannachtWind: getWindDirection(data.daily[0].wind_deg),
        provincieTemp: Math.round(data.daily[1].temp.day),
        provincieIcon: data.daily[1].weather[0].id,
        provincieWind: getWindDirection(data.daily[1].wind_deg),
        overzichtIcon1: data.daily[2].weather[0].id,
        overzichtTempMax1: Math.round(data.daily[2].temp.max),
        overzichtTempMin1: Math.round(data.daily[2].temp.min),
        overzichtWindIcon1: getWindDirection(data.daily[2].wind_deg),
        overzichtWindText1: getWindSpeed(data.daily[2].wind_speed),
        overzichtIcon2: data.daily[3].weather[0].id,
        overzichtTempMax2: Math.round(data.daily[3].temp.max),
        overzichtTempMin2: Math.round(data.daily[3].temp.min),
        overzichtWindIcon2: getWindDirection(data.daily[3].wind_deg),
        overzichtWindText2: getWindSpeed(data.daily[3].wind_speed),
        overzichtIcon3: data.daily[4].weather[0].id,
        overzichtTempMax3: Math.round(data.daily[4].temp.max),
        overzichtTempMin3: Math.round(data.daily[4].temp.min),
        overzichtWindIcon3: getWindDirection(data.daily[4].wind_deg),
        overzichtWindText3: getWindSpeed(data.daily[4].wind_speed),
        overzichtIcon4: data.daily[5].weather[0].id,
        overzichtTempMax4: Math.round(data.daily[5].temp.max),
        overzichtTempMin4: Math.round(data.daily[5].temp.min),
        overzichtWindIcon4: getWindDirection(data.daily[5].wind_deg),
        overzichtWindText4: getWindSpeed(data.daily[5].wind_speed),
        overzichtIcon5: data.daily[6].weather[0].id,
        overzichtTempMax5: Math.round(data.daily[6].temp.max),
        overzichtTempMin5: Math.round(data.daily[6].temp.min),
        overzichtWindIcon5: getWindDirection(data.daily[6].wind_deg),
        overzichtWindText5: getWindSpeed(data.daily[6].wind_speed),
        overzichtIcon6: data.daily[7].weather[0].id,
        overzichtTempMax6: Math.round(data.daily[7].temp.max),
        overzichtTempMin6: Math.round(data.daily[7].temp.min),
        overzichtWindIcon6: getWindDirection(data.daily[7].wind_deg),
        overzichtWindText6: getWindSpeed(data.daily[7].wind_speed)
      });
    });

    //Kust
    owmGetData("51.2153101", "2.8866706").then(data => {
      this.setState({
        belgieTemp1: Math.round(data.daily[1].temp.day),
        belgieIcon1: data.daily[1].weather[0].id,
        belgieWind2: getWindDirection(data.daily[1].wind_deg),
        belgieWindText2: getWindSpeed(data.daily[1].wind_speed)
      });
    });

    //Oost Vlaanderen
    owmGetData("51.0734547", "3.687112").then(data => {
      this.setState({
        belgieTemp2: Math.round(data.daily[1].temp.day),
        belgieIcon2: data.daily[1].weather[0].id
      });
    });

    //Antwerpen
    owmGetData("51.2603015", "4.2176376").then(data => {
      this.setState({
        belgieTemp3: Math.round(data.daily[1].temp.day),
        belgieIcon3: data.daily[1].weather[0].id
      });
    });

    //Brussel
    owmGetData("50.8477584", "4.3641418").then(data => {
      this.setState({
        belgieTemp4: Math.round(data.daily[1].temp.day),
        belgieIcon4: data.daily[1].weather[0].id,
        belgieWind: getWindDirection(data.daily[1].wind_deg),
        belgieWindText: getWindSpeed(data.daily[1].wind_speed)
      });
    });

    //Limburg
    owmGetData("50.9245441", "5.243426").then(data => {
      this.setState({
        belgieTemp5: Math.round(data.daily[1].temp.day),
        belgieIcon5: data.daily[1].weather[0].id
      });
    });

    //Ardennen
    owmGetData("50.1395935", "5.2603147").then(data => {
      this.setState({
        belgieTemp6: Math.round(data.daily[1].temp.day),
        belgieIcon6: data.daily[1].weather[0].id
      });
    });

    var d = new Date();
    var n = d.getDay();
    this.setState({
      provincieTitle: dayOfWeek(n + 1),
      belgieTitle: dayOfWeek(n + 1),
      overzichtTitle1: dayOfWeekShort(n + 2),
      overzichtTitle2: dayOfWeekShort(n + 3),
      overzichtTitle3: dayOfWeekShort(n + 4),
      overzichtTitle4: dayOfWeekShort(n + 5),
      overzichtTitle5: dayOfWeekShort(n + 6),
      overzichtTitle6: dayOfWeekShort(n + 7),
      vannachtWarning: false,
      vannachtWarningIcon: "",
      provincieWarning: false,
      provincieWarningIcon: ""
    });
  }

  saveDataClick() {
    var d = new Date();
    this.setState({ lastSaved: d.toString() }, () => {
      var data = {
        vannacht: {
          temp: this.state.vannachtTemp,
          icon: this.state.vannachtIcon,
          wind: this.state.vannachtWind,
          warning: this.state.vannachtWarning,
          warningIcon: this.state.vannachtWarningIcon
        },
        dagProvincie: {
          title: this.state.provincieTitle,
          temp: this.state.provincieTemp,
          icon: this.state.provincieIcon,
          wind: this.state.provincieWind,
          warning: this.state.provincieWarning,
          warningIcon: this.state.provincieWarningIcon
        },
        dagBelgie: {
          title: this.state.belgieTitle,
          temp1: {
            temp: this.state.belgieTemp1,
            icon: this.state.belgieIcon1
          },
          temp2: {
            temp: this.state.belgieTemp2,
            icon: this.state.belgieIcon2
          },
          temp3: {
            temp: this.state.belgieTemp3,
            icon: this.state.belgieIcon3
          },
          temp4: {
            temp: this.state.belgieTemp4,
            icon: this.state.belgieIcon4
          },
          temp5: {
            temp: this.state.belgieTemp5,
            icon: this.state.belgieIcon5
          },
          temp6: {
            temp: this.state.belgieTemp6,
            icon: this.state.belgieIcon6
          },
          wind: this.state.belgieWind,
          windText: this.state.belgieWindText,
          wind2: this.state.belgieWind2,
          windText2: this.state.belgieWindText2
        },
        overzicht: {
          temp1: {
            title: this.state.overzichtTitle1,
            icon: this.state.overzichtIcon1,
            tempMax: this.state.overzichtTempMax1,
            tempMin: this.state.overzichtTempMin1,
            windIcon: this.state.overzichtWindIcon1,
            windText: this.state.overzichtWindText1
          },
          temp2: {
            title: this.state.overzichtTitle2,
            icon: this.state.overzichtIcon2,
            tempMax: this.state.overzichtTempMax2,
            tempMin: this.state.overzichtTempMin2,
            windIcon: this.state.overzichtWindIcon2,
            windText: this.state.overzichtWindText2
          },
          temp3: {
            title: this.state.overzichtTitle3,
            icon: this.state.overzichtIcon3,
            tempMax: this.state.overzichtTempMax3,
            tempMin: this.state.overzichtTempMin3,
            windIcon: this.state.overzichtWindIcon3,
            windText: this.state.overzichtWindText3
          },
          temp4: {
            title: this.state.overzichtTitle4,
            icon: this.state.overzichtIcon4,
            tempMax: this.state.overzichtTempMax4,
            tempMin: this.state.overzichtTempMin4,
            windIcon: this.state.overzichtWindIcon4,
            windText: this.state.overzichtWindText4
          },
          temp5: {
            title: this.state.overzichtTitle5,
            icon: this.state.overzichtIcon5,
            tempMax: this.state.overzichtTempMax5,
            tempMin: this.state.overzichtTempMin5,
            windIcon: this.state.overzichtWindIcon5,
            windText: this.state.overzichtWindText5
          },
          temp6: {
            title: this.state.overzichtTitle6,
            icon: this.state.overzichtIcon6,
            tempMax: this.state.overzichtTempMax6,
            tempMin: this.state.overzichtTempMin6,
            windIcon: this.state.overzichtWindIcon6,
            windText: this.state.overzichtWindText6
          }
        },
        samenvatting: {
          text: this.state.samenvatting
        },
        lastSaved: this.state.lastSaved
      };

      saveData("rob", data);
    });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleChangeCheckBox = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleChangeSelect = (option, name) => {
    this.setState({ [name]: option });
  };

  render() {
    return (
      <Main
        fill="vertical"
        flex="grow"
        overflow="auto"
        pad="xlarge"
        justify="start"
      >
        <div className="atvHeader"></div>
        <Grid columns="small" margin="small">
          <Button label="Load data"/>
        </Grid>
        <Heading level="4">Vannacht</Heading>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <TextInput
            placeholder="Temp"
            value={this.state.vannachtTemp}
            onChange={this.handleChange("vannachtTemp")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.vannachtIcon}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "vannachtIcon")
            }
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.vannachtWind}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "vannachtWind")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <CheckBox
            label="Warning Icon"
            checked={this.state.vannachtWarning}
            onChange={this.handleChangeCheckBox("vannachtWarning")}
          />
          <Select
            options={warning}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Warning"
            value={this.state.vannachtWarningIcon}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "vannachtWarningIcon")
            }
          />
        </Grid>
        <Heading level="4" size="xlarge">
          Dag Provincie
        </Heading>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <Select
            options={days}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.provincieTitle}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieTitle")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <TextInput
            placeholder="Temp"
            value={this.state.provincieTemp}
            onChange={this.handleChange("provincieTemp")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.provincieIcon}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieIcon")
            }
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.provincieWind}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieWind")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <CheckBox
            label="Warning Icon"
            checked={this.state.provincieWarning}
            onChange={this.handleChangeCheckBox("provincieWarning")}
          />
          <Select
            options={warning}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Warning"
            value={this.state.provincieWarningIcon}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "provincieWarningIcon")
            }
          />
        </Grid>
        <Heading level="4">Dag België</Heading>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <Select
            options={days}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.belgieTitle}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieTitle")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Kust</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.belgieTemp1}
            onChange={this.handleChange("belgieTemp1")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.belgieIcon1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon1")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Oost-Vlaanderen</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.belgieTemp2}
            onChange={this.handleChange("belgieTemp2")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.belgieIcon2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon2")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Antwerpen</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.belgieTemp3}
            onChange={this.handleChange("belgieTemp3")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.belgieIcon3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon3")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Brussel</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.belgieTemp4}
            onChange={this.handleChange("belgieTemp4")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.belgieIcon4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon4")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Limburg</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.belgieTemp5}
            onChange={this.handleChange("belgieTemp5")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.belgieIcon5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon5")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
          alignContent="center"
          align="center"
        >
          <Text textAlign="start">Ergens</Text>
          <TextInput
            placeholder="Temp"
            value={this.state.belgieTemp6}
            onChange={this.handleChange("belgieTemp6")}
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.belgieIcon6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieIcon6")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.belgieWind}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieWind")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Kust Text"
            value={this.state.belgieWindText}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieWindText")
            }
          />
        </Grid>
        <Grid
          columns={{ size: "small", count: "fill" }}
          margin="small"
          gap="medium"
        >
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Kust"
            value={this.state.belgieWind2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieWind2")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Kust Text"
            value={this.state.belgieWindText2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "belgieWindText2")
            }
          />
        </Grid>
        <Heading level="4">Overzicht</Heading>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.overzichtTitle1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle1")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.overzichtIcon1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon1")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.overzichtTempMax1}
            onChange={this.handleChange("overzichtTempMax1")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.overzichtTempMin1}
            onChange={this.handleChange("overzichtTempMin1")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.overzichtWindIcon1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon1")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.overzichtWindText1}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText1")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.overzichtTitle2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle2")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.overzichtIcon2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon2")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.overzichtTempMax2}
            onChange={this.handleChange("overzichtTempMax2")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.overzichtTempMin2}
            onChange={this.handleChange("overzichtTempMin2")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.overzichtWindIcon2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon2")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.overzichtWindText2}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText2")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.overzichtTitle3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle3")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.overzichtIcon3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon3")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.overzichtTempMax3}
            onChange={this.handleChange("overzichtTempMax3")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.overzichtTempMin3}
            onChange={this.handleChange("overzichtTempMin3")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.overzichtWindIcon3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon3")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.overzichtWindText3}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText3")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.overzichtTitle4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle4")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.overzichtIcon4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon4")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.overzichtTempMax4}
            onChange={this.handleChange("overzichtTempMax4")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.overzichtTempMin4}
            onChange={this.handleChange("overzichtTempMin4")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.overzichtWindIcon4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon4")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.overzichtWindText4}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText4")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.overzichtTitle5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle5")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.overzichtIcon5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon5")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.overzichtTempMax5}
            onChange={this.handleChange("overzichtTempMax5")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.overzichtTempMin5}
            onChange={this.handleChange("overzichtTempMin5")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.overzichtWindIcon5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon5")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.overzichtWindText5}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText5")
            }
          />
        </Grid>
        <Grid columns="xsmall" gap="medium" rows="xxsmall">
          <Select
            options={daysShort}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="dag"
            value={this.state.overzichtTitle6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtTitle6")
            }
          />
          <Select
            options={icons}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Icon"
            labelKey="label"
            valueKey="id"
            value={this.state.overzichtIcon6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtIcon6")
            }
          />
          <TextInput
            placeholder="° max"
            value={this.state.overzichtTempMax6}
            onChange={this.handleChange("overzichtTempMax6")}
          />
          <TextInput
            placeholder="° min"
            value={this.state.overzichtTempMin6}
            onChange={this.handleChange("overzichtTempMin6")}
          />
          <Select
            options={wind}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind"
            value={this.state.overzichtWindIcon6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindIcon6")
            }
          />
          <Select
            options={windSpeed}
            replace={false}
            closeOnChange={true}
            multiple={false}
            placeholder="Wind Speed"
            value={this.state.overzichtWindText6}
            onChange={({ option }) =>
              this.handleChangeSelect(option, "overzichtWindText6")
            }
          />
        </Grid>
        <Heading level="4">Samenvatting</Heading>
        <Grid columns="large">
          <TextArea
            size="large"
            value={this.state.samenvatting}
            onChange={this.handleChange("samenvatting")}
          />
        </Grid>
        <Grid
          columns="small"
          justify="end"
          justifyContent="end"
          align="center"
          alignContent="start"
          margin="small"
        >
          <Button
            label="Save"
            gap="small"
            fill="horizontal"
            plain={false}
            primary={true}
            reverse={true}
            onClick={this.saveDataClick}
          />
          <Text textAlign="start" size="xsmall">
            {this.state.lastSaved}
          </Text>
        </Grid>
      </Main>
    );
  }
}

export default ROB;
